import * as angular from "angular";

angular
  .module('bringoz.admin.lean-planning')
  .filter('bringozPositiveNumber', bringozPositiveNumber);

function bringozPositiveNumber() {
  return function bringozPositiveNumber(number) {
    if (number < 0) {
      return 0;
    } else {
      return number;
    }
  };
}
